module.exports = __webpack_public_path__ + "media/images/home/hero_widget_mobile_bg-615725110227a44ae3babe49a21d118d.jpg";